import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { ProfileService } from 'core/services/profile.service';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AgentsCacheService } from '../services';

export const AgentsCacheResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  agentsCacheService: AgentsCacheService = inject(AgentsCacheService),
  profileService: ProfileService = inject(ProfileService)
): Observable<any> => {
  return profileService.resolve().pipe(
    switchMap(() => {
      return agentsCacheService.getGlobalAgents();
    })
  );
};
